// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //paein
  BaaseUrl: "https://goldisapi.gonbadedanesh.com",
  ReportBaseUrl: "https://goldisreport.gonbadedanesh.com/",

  //bala
  //BaaseUrl: "http://services.gonbadedanesh.com",
  //ReportBaseUrl: "https://reports.natoos.com/",
  AdobeConnect: "https://ac1.gonbadedanesh.com",
  //Convert
  // BaaseUrl: "http://188.75.69.58:8081",
  // ReportBaseUrl: "http://188.75.69.58:8082/",

  //ReportBaseUrl: "http://reports.natoos.gosafir.com/",
  dateFormat: "YYYY/M/D HH:mm",
  fullDateFaFormat: "jYYYY/jM/jD HH:mm",
  dateFaFormat: "jYYYY/jMM/jDD",
  versionCheckURL: 'version.json',
  siteTitle: 'سامانه مدیریت آموزش :: گنبد دانش ::'
};
